if (!customElements.get('custom-navigation')) {
  class CustomNavigation extends HTMLElement {
    constructor() {
      super();
      this.select = this.querySelector('[data-select]');
      this.list = this.querySelector('[data-list]');
      this.listItems = [];
      this.optionItems = [];
      this.items = [];
    }

    connectedCallback() {
      this.getItems();
      this.populateList();
      this.populateSelect();
    }

    getItems() {
      const titleItems = document.querySelectorAll('.article__content h2');
      const relatedProducts = document.querySelector('[data-section-type="related"]');
      if (titleItems.length > 0) {
        titleItems.forEach((item, i) => {
          this.items.push({
            title: item.textContent,
            value: `h2[data-index="${i}"]`,
          });
          item.setAttribute('data-index', i);
        });
      }
      if (relatedProducts && relatedProducts.childElementCount > 0) {
        this.items.push({
          title: relatedProducts.querySelector('h2').innerText,
          value: `#${relatedProducts.id}`,
        });
      }
    }

    populateList() {
      if (this.items.length > 0 && this.list) {
        this.items.forEach((item, index) => {
          const li = document.createElement('li');
          const anchor = document.createElement('a');
          anchor.classList.add('widget__link');
          anchor.textContent = item.title;
          anchor.href = item.value;
          li.classList.add('widget__links--element');
          li.appendChild(anchor);
          this.list.appendChild(li);
          this.listItems.push(li);
          anchor.addEventListener('click', (event) => {
            event.preventDefault();
            this.goToPos(item.value);
          });
        });
      }
    }

    populateSelect() {
      if (this.items.length > 0 && this.select) {
        this.items.forEach((item) => {
          const option = document.createElement('option');
          option.value = item.value;
          option.textContent = item.title;
          this.select.appendChild(option);
          this.optionItems.push(option);
        });
        this.select.addEventListener('change', (event) => {
          const value = event.target.value;
          if (value) {
            this.goToPos(value);
          }
        });
      }
    }

    setNewActiveItem(selector) {
      this.listItems.forEach((item) => {
        item.classList.toggle('widget__links--active', item.querySelector('a').getAttribute('href') === selector);
      });
      this.optionItems.forEach((item) => {
        item.classList.toggle('widget__links--active', item.value === selector);
      });
    }

    goToPos(selector) {
      this.setNewActiveItem(selector);
      const element = document.querySelector(selector);
      const {headerHeight} = window.theme.readHeights();

      if (element) {
        window.scrollTo({
          top: element.getBoundingClientRect().top + window.scrollY - headerHeight - 10,
          behavior: 'smooth'
        });
      }
    }
  }

  customElements.define('custom-navigation', CustomNavigation);
}
